import _ from 'lodash';
import EAInputBloc from '../../../../../../../components/common/EAInputBloc';
import i18next from 'i18next';
import EAAutoCompleteInput from '../../../../../../../components/inputs/EAAutoCompleteInput';
import CalculatorSelectInput from '../../../calculatorInputs/CalculatorSelectInput';
import CalculatorStandardInput from '../../../calculatorInputs/CalculatorStandardInput';
import React from 'react';

const EqualValue = ({
  fieldName,
  showLabel,
  availableValueOptions,
  variantAutoComplete,
  readOnly = false
}) => {
  const label = showLabel ? i18next.t('calculator.dialog.create.label.values') : '';

  if (!_.isEmpty(availableValueOptions)) {
    if (variantAutoComplete === true) {
      return (
        <EAInputBloc
          label={label}
          customLabelStyle={{ fontSize: '14px' }}
        >
          <EAAutoCompleteInput
            fieldName={`${fieldName}.${0}`}
            options={availableValueOptions}
            placeholder={i18next.t(
              `rules.configuration.criteria.fields.value.autocompletePlaceholder`
            )}
            isRequired
            multiple={false}
            triggerOnContinue
            disabled={readOnly}
          />
        </EAInputBloc>
      );
    }
    return (
      <CalculatorSelectInput
        fieldName={`${fieldName}.${0}`}
        label={label}
        placeholder={i18next.t(
          `calculator.dialog.create.placeholder.selectValues`
        )}
        options={availableValueOptions}
        uxVariant="criteriaInput"
        variant="standard"
        isRequired
        validate={() => null}
        labelVariant="chip"
        triggerOnContinue
        disabled={readOnly}
      />
    );
  }

  return (
    <CalculatorStandardInput
      fieldName={`${fieldName}.${0}`}
      isRequired
      label={`${
        showLabel ? i18next.t('calculator.dialog.create.label.values') : ''
      }`}
      placeholder={i18next.t(
        `calculator.dialog.create.placeholder.indicateValue`
      )}
      uxVariant="criteriaInput"
      variant="standard"
      validate={() => null}
      triggerOnContinue
      disabled={readOnly}
    />
  );
};

export default EqualValue;
